module.exports = __webpack_public_path__ + "static/media/prepared.f1670a72.png";